module.exports = __webpack_public_path__ + "static/0011-e62cab04795667f3567cd9dc6a781ad5.png";